/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Password_ChangeInputs */



/**
* | output |
* | --- |
* | "Change password" |
*
* @param {Profile_Password_ChangeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_password_change = /** @type {((inputs?: Profile_Password_ChangeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Password_ChangeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Changer le mot de passe")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar contraseña")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Alterar senha")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cambia password")
	return /** @type {LocalizedString} */ ("Change password")
});